import React from "react";
import { render } from "react-dom";
import track from "react-tracking";
import Root from './root.js';
import { getPath } from "./actions/commonActions.js";

const logActivity = (data) => {
    const user = data.user ? data.user : JSON.parse(localStorage.getItem('user'))
    const PLATFORM = localStorage.getItem('platform');
    const location = localStorage.getItem('LOCATION')
    if (user && user.SID) {
      const userDetails = {
        "SID": user.SID,
        "UDES": user.UD,
        "UID": user.UID,
        "Platform": PLATFORM,
        "Location": location
      }
      data.userDetails = userDetails
      data.time = new Date();
      if (data.hasOwnProperty('wsDetails') || data.hasOwnProperty('wsResponse')) {
        delete data.widgetDetails;
        delete data.user; 
      }
      fetch(`${getPath("api")}/getAllLogsData`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Cache-Control": "no-cache",
          "SID": user.SID,
          "username": user.UID,
          "location": location,
          "platform": PLATFORM
        },
        body: JSON.stringify(data)
      });
    }
}

const TrackedApp = track(
  // app-level tracking data
  {
    app: "Trader",
  },
  // top-level options
  {
    dispatch: (data) => {
      logActivity(data)
    }
  }
)(Root);


render(<TrackedApp />, document.getElementById("content"));
